import { actionCreators as FeedItemActionCreators } from '@app/components/FeedItem/modules/feedItems'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalSocialNetworksState,
  selectSocialNetworks,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ConnectionViewPage from '../components/ConnectionViewPage'
import {
  actionCreators,
  IConnectionViewState,
  selectEarnings,
  selectError,
  selectIsDeleting,
  selectIsLoading,
  selectItem,
  selectPermissions,
  selectScope,
  selectShowConfirmDelete,
} from '../modules/connectionView'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IConnectionViewState & ICurrentUserState & IGlobalSocialNetworksState
    >({
      earnings: selectEarnings(),
      error: selectError(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      item: selectItem(),
      permissions: selectPermissions(),
      scope: selectScope(),
      showConfirmDelete: selectShowConfirmDelete(),
      socialNetworks: selectSocialNetworks(),
      user: selectCurrentUser(),
    }),
    Object.assign({}, actionCreators, FeedItemActionCreators),
  )(ConnectionViewPage),
)
